import React from 'react';
import { handleAccessibleEnter, createEvent } from '../helpers';

const Toggle = ({ value, onChange, name, ...props }) => {
  return (
    <>
      <input
        id={name}
        type={'checkbox'}
        checked={value}
        name={name}
        {...props}
      />
      <label
        onClick={() => onChange(createEvent({ name, value: !value }))}
        onKeyDown={({ key }) =>
          handleAccessibleEnter({
            event: createEvent({ name, value: !value }),
            key,
            onChange,
          })
        }
        tabIndex={0}
      />
    </>
  );
};

export default Toggle;
